module.exports = __webpack_public_path__ + "media/app/assets/imgs/exchange/connect-610720b8c4bf8a5c0d52d59db4e4416e.png";